module.exports = __webpack_public_path__ + "media/images/notice-f0a68e4c.png";